import request from '@/utils/request'

let TopicApi = {

  /*话题列表*/
  list(data) {
    return request._post('/shop/plus.topic.Index/index', data);
},
/*添加话题*/
add(data) {
    return request._post('/shop/plus.topic.Index/add', data);
},
/*修改话题*/
edit(data) {
    return request._post('/shop/plus.topic.Index/edit', data);
},
/*删除话题*/
del(data) {
    return request._post('/shop/plus.topic.Index/del', data);
},
/*话题详情*/
detail(data) {
  return request._post('/shop/plus.topic.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.topic.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.topic.Setting/getSetting', data, errorback);
    },
}
export default TopicApi;



// WEBPACK FOOTER //
// ./src/api/topic.js